import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, TextField } from '@mui/material'
import { useState } from 'react'
import parseUrl from 'url-parse'

interface EditDialogProps {
  fieldName?: string
  fieldValue?: string
  maxLength?: number
  onCancel?: () => void
  onSave?: (value: string) => void
  open?: boolean
}

const EditDialogOpen: React.FC<EditDialogProps> = (props) => {
  const { onCancel, onSave, fieldName, open = false, maxLength = 1024 } = props

  const [fieldValue, setFieldValue] = useState(props.fieldValue ?? '')

  const onSaveClicked = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation()
    const isValid = fieldValue.length === 0 || parseUrl(fieldValue)?.protocol === 'https:'
    if (!isValid) {
      return 'Yo! Url must start with https: or must be empty'
    } else {
      onSave?.(fieldValue)
    }
  }

  return (
    <Dialog onClose={onCancel} open={open}>
      <DialogTitle>Edit Link</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" minWidth={300}>
          <FormControl fullWidth>
            <TextField
              inputProps={{ maxLength }}
              label={fieldName}
              onChange={(event) => setFieldValue(event.target.value)}
              value={fieldValue}
              variant="outlined"
            />
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box display="flex" width="100%">
          <Box>
            <Button onClick={onCancel} variant="text">
              Cancel
            </Button>
          </Box>
          <Box flexGrow={1}></Box>
          <Box>
            <Button onClick={onSaveClicked} variant="text">
              Save
            </Button>
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

const EditLinkDialog: React.FC<EditDialogProps> = (props) => {
  const { open } = props
  if (open) {
    return <EditDialogOpen {...props} />
  } else {
    return null
  }
}

export default EditLinkDialog
